import React from 'react';
import { ISmartProps, KIND as _KIND, ROLE as _ROLE, CLOSE_SOURCE as _CLOSE_SOURCE } from './types';
import { View } from './view';

export type KIND = _KIND;
export type ROLE = _ROLE;
export type CLOSE_SOURCE = _CLOSE_SOURCE;
export type DialogProps = Omit<ISmartProps, 'css'>;

export const Dialog = React.forwardRef((props: DialogProps, ref: any) => {
	return <View {...props} ref={ref} />;
});

export { DialogFooter } from './view';
